import { tokenAliasOrValue } from "./base";
import { z } from "zod";
export const FontWeightValue = z.string();
export const FontWeightTokenData = tokenAliasOrValue(FontWeightValue);
